import React from 'react';
import st from "../common.module.scss";
import FlexLine from "@elements/flexLine/FlexLine";
import { TextType } from "@baseTypes/baseType";
import ChartHeader from "@elements/chart/ChartHeader";
import Tx from "@baseTypes/naming";
import { EmptyTextBlock } from "@pages/dashboard/crops/empty";

const Empty = () => {
	return (
		<div className={st.empty_block}>
			<FlexLine textType={TextType.Header} className={st.header}>
				<ChartHeader>{Tx.StateCrops}</ChartHeader>
				<div className={st.total_label}>0 Га
				</div>
			</FlexLine>
			<svg width="352" height="298" viewBox="0 0 352 298" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_11156_6770)">
					<rect x="0.5" y="0.5" width="351" height="23" rx="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="64.582" y="0.5" width="204.616" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="64.582" y="0.5" width="204.616" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="64.582" y="0.5" width="149.531" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="64.582" y="0.5" width="81.5932" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
					<rect x="29.6614" y="0.5" width="33.9208" height="23" fill="#E6E6E6" stroke="#E6E6E6"/>
					<path d="M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H28.6613V23.5H5C2.51471 23.5 0.5 21.4853 0.5 19V5Z"
						  fill="#E6E6E6" stroke="#E6E6E6"/>
					<g clipPath="url(#clip1_11156_6770)">
						<rect y="40" width="174" height="14" rx="7" fill="#E6E6E6"/>
						<rect x="300" y="40" width="52" height="14" rx="7" fill="#E6E6E6"/>
						<circle cx="8" cy="88" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
						<rect x="22" y="78" width="165" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<rect x="276" y="78" width="76" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<circle cx="8" cy="118" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
						<rect x="22" y="108" width="179" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<rect x="301" y="108" width="51" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<circle cx="8" cy="148" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
						<rect x="22" y="138" width="178" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<rect x="263" y="138" width="89" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<circle cx="8" cy="178" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
						<rect x="20" y="168" width="191" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<rect x="273" y="168" width="79" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<circle cx="8" cy="208" r="4.5" fill="#E6E6E6" stroke="#E6E6E6"/>
						<rect x="22" y="198" width="112" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<rect x="296" y="198" width="56" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<circle cx="8" cy="238" r="5.5" fill="#E6E6E6" stroke="#E6E6E6"/>
						<rect x="22" y="228" width="210" height="12.25" rx="6.125" fill="#E6E6E6"/>
						<rect x="285" y="228" width="67" height="12.25" rx="6.125" fill="#E6E6E6"/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_11156_6770">
						<rect width="352" height="298" fill="white"/>
					</clipPath>
					<clipPath id="clip1_11156_6770">
						<rect width="352" height="258" fill="white" transform="translate(0 40)"/>
					</clipPath>
				</defs>
			</svg>

			<div className={st['empty_block__blur']}>
				<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="400" height="400" fill="url(#paint0_linear_11156_6822)"/>
					<defs>
						<linearGradient id="paint0_linear_11156_6822" x1="200" y1="42.6063" x2="200" y2="311.874"
										gradientUnits="userSpaceOnUse">
							<stop offset="0.460045" stopColor="white" stopOpacity="0"/>
							<stop offset="0.831741" stopColor="white" stopOpacity="0.958507"/>
							<stop offset="1" stopColor="white"/>
						</linearGradient>
					</defs>
				</svg>

			</div>

			<EmptyTextBlock subtitle={'Для просмотра выберите другие департамент или организацию'} />
		</div>
	)
}

export default Empty;